import { compact } from 'lodash-es';
import { ErrorResponse, ServerError } from '~/infra/error-response/ErrorResponse';
export function formatVendorAddress(postalAddress) {
    const parts = compact([
        postalAddress.addressOne,
        postalAddress.addressTwo,
        compact([
            postalAddress.city,
            postalAddress.state,
            postalAddress.postalCode
        ]).join(', ')
    ]);
    return parts.length > 0 ? parts.join('\n') : undefined;
}
export function applyApprovalError(config) {
    const errorResponse = new ErrorResponse(config.error);
    if (errorResponse.hasServerError(ServerError.InvoiceAlreadyApproved)) return config.onAlreadyApproved();
    if (errorResponse.hasServerError(ServerError.InvoiceWasVoided)) return config.onVoided();
    config.onUnclassified();
}
